import { skipToken, useQuery, useQueryClient } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { ApiError, OurUseQueryOptions } from "@nens/react-query-utils";
import { Download, getHCCApi } from "@nens/threedi/openapi-client";

import { invalidateIfOutdated } from "./hooks/if-outdated";

const fetchHccGridadmin = async (modelId: number): Promise<Download | undefined> => {
  try {
    return await getHCCApi().threedimodelsGridadminDownload({ id: modelId });
  } catch (error) {
    // A schematisation might not have a gridadmin for the model after it has been copied from the catalogue
    if (error instanceof ApiError && error.getStatusCode() === 400) {
      return undefined;
    }
    throw error;
  }
};

const getHccGridadminQuery = (
  modelId: number | undefined
): OurUseQueryOptions<Download | undefined> => {
  return getRanaApiV1().getQueryOptions({
    queryKey: ["hcc-gridadmin", modelId],
    queryFn: modelId !== undefined ? () => fetchHccGridadmin(modelId) : skipToken,
  });
};

export const useHccGridadminQuery = (modelId: number | undefined) =>
  useQuery(getHccGridadminQuery(modelId));

// INVALIDATION

export const useInvalidateIfOutdatedHccGridadminQuery = (modelId: number | undefined) => {
  const queryClient = useQueryClient();
  return (finishedAt: Date) => {
    invalidateIfOutdated(queryClient, finishedAt, getHccGridadminQuery(modelId).queryKey);
  };
};
